export default "__VITE_ASSET__CFcqbEYF__"